import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import React from "react";
import { Box } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { useFooterContentQuery } from "../../generated/graphql";
import { concatClasses } from "../../utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PrivacyContent = function PrivacyContent(_ref) {
  var _data$textBlock;

  var className = _ref.className;

  var _useFooterContentQuer = useFooterContentQuery(),
      data = _useFooterContentQuer.data;

  if (!(data !== null && data !== void 0 && (_data$textBlock = data.textBlock) !== null && _data$textBlock !== void 0 && _data$textBlock.text)) {
    return null;
  }

  return ___EmotionJSX(PrivacyContentContainer, {
    className: concatClasses(className, "static-content privacy")
  }, ___EmotionJSX("h1", {
    style: {
      textAlign: "center"
    }
  }, "Privacy Policy"), ___EmotionJSX(Box, {
    dangerouslySetInnerHTML: {
      __html: data.textBlock.text
    }
  }));
};
var PrivacyContentContainer = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top: 20px;\n  padding-bottom: 40px;\n  padding-left: 20px;\n  padding-right: 20px;\n\n  font-family: Biennale, Helvetica, Arial, sans-serif;\n  font-weight: 100;\n\n  hr {\n    border-top: 1px solid #ddd;\n    margin: 1.25rem 0;\n  }\n\n  a {\n    text-decoration: none;\n    color: ", ";\n  }\n\n  /* Nested numbering */\n  ol {\n    counter-reset: item;\n    padding-inline-start: 0px;\n\n    li {\n      display: block;\n      position: relative;\n    }\n\n    li:before {\n      content: counters(item, \".\") \". \";\n      counter-increment: item;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    li {\n      padding-left: 30px;\n      li {\n        padding-left: 38px;\n        li {\n          padding-left: 53px;\n        }\n      }\n    }\n  }\n\n  /* List styles */\n  ol,\n  ul,\n  p {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n\n  ol,\n  ul {\n    ol,\n    ul {\n      margin-top: 10px;\n    }\n\n    li {\n      margin-bottom: 10px;\n    }\n  }\n\n  /* Heading Styles */\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 0 0 0.7em;\n    color: #222;\n    font-family: Biennale, Helvetica, Arial, sans-serif;\n    font-weight: 600;\n    line-height: 1.3;\n    font-size: 30px;\n  }\n\n  .updated-date {\n    color: #777;\n    margin-bottom: 0;\n    font-size: 0.857rem;\n  }\n\n  p {\n    margin: 0 0 1.25em;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n"])), themeGet("colors.secondary", "#0064E4"));